import axiosInstance from './axiosInstance';

export async function getNotifications(page = 1, limit = 15) {
  const response = await axiosInstance.get('/notifications/get-notifications.php', {
    params: { page, limit },
  });
  return response.data;
}

export async function markNotificationRead(id) {
  const response = await axiosInstance.post('/notifications/mark-notification-read.php', { id });
  return response.data;
}

export async function markAllNotificationsRead() {
  const response = await axiosInstance.post('/notifications/mark-notification-read.php', { mark_all: true });
  return response.data;
}